<template>
  <div class="custom-alert-overlay">
    <div class="custom-alert-confirm" :class="brandClass">
      <div v-if="showCloseButton" 
        class="custom-alert-close" 
        :class="button_close_disabled && 'disabled'"
        @click="!button_close_disabled && close(oneUtils.enums.closedBy.BUTTON)" 
        @keydown="ariaClick" 
        role="button" 
        :tabindex="button_close_disabled ? '-1' : '0'">
      </div>
      <div class="custom-confirm-title" :class="brandClass">
        {{ $toUpperCase(title) }}
      </div>
      <div class="custom-confirm-content" :class="brandClass" v-html="content">
      </div>
      <div class="confirm-content" :class="brandClass">
        {{ subsubtitle }}
      </div>
      <slot name="internal-content"></slot>
      <div class="custom-confirm-buttons">
        <OneButton
          :brandClass="brandClass"
          v-if="button_confirm_label"
          :profileStyle="true"
          :type="'primary'"
          :label="button_confirm_label"
          @click="$emit('confirm')"
          :disabled="button_confirm_disabled"
        />
        <OneButton
          :brandClass="brandClass"
          class="full"
          v-if="button_full_label"
          :profileStyle="true"
          :type="'primary'"
          :label="button_full_label"
          @click="$emit('full')"
          :disabled="button_full_disabled"
        />
        <OneButton
         v-if="button_cancel_label"
          :brandClass="brandClass"
          :profileStyle="true"
          :type="'secondary'"
          :label="button_cancel_label"
          @click="close(oneUtils.enums.closedBy.CANCEL)"
        />
      </div>
      <slot class="external-content" name="external-content"></slot>
    </div>
  </div>
</template>

<script>
import oneUtils from "../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import { defineComponent } from 'vue';
import OneButton from "../../../gcdm-one-library/gcdm-one-button/src/OneButton";

export default defineComponent({
  name: "Confirm",
  components: {OneButton},
  inject: ['$toUpperCase'],
  mixins: [oneUtils.accessibilityMixin], 
  props: {
    brandClass:{
      type: String,
      required: false,
      default: '__b'
    },
    title: String,
    content: String,
    button_confirm_label: null,
    button_cancel_label: null,
    button_full_label: null,
    subsubtitle: null,
    showCloseButton:{
      default: true
    },
    button_confirm_disabled:{
      default: false
    },
    button_full_disabled:{
      default: false
    },
    button_close_disabled:{
      default: false
    }
  },
  data: () => ({
    oneUtils: oneUtils
  }),
  mounted(){
    const body = document.getElementById("body");
    if(body) body.style["overflow-y"] = "hidden";

    setTimeout(() => {
      const container = document.querySelector('.custom-alert-overlay');
      if(container) {
        const list = container.querySelectorAll('[tabindex = "0"], a, button');
        list[0] && list[0].focus();
        this.navigateInModal(list, ()=>{this.$emit('close')});
      }
    }, 500);
  },
  unmounted() {
    const body = document.getElementById("body");
    if(body) body.style["overflow-y"] = "scroll";
  },
  methods: {
    close(closedBy) {
      const body = document.getElementById("body");
      if(body) body.style["overflow-y"] = "scroll";

      this.$emit('close', closedBy);
    }
  }
});
</script>
<style lang="scss" scoped>
@import './styles/_fonts.scss';
@import './styles/_variables.scss';
.custom-alert-overlay{
  z-index: 30;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #00000047;
  display: flex;
  justify-content: center;
  align-items: center;
  .custom-alert-confirm {
    background: white;
    width: 736px;
    padding: 70px 96px 80px;
    position: relative;
    &.__d{
      background-color: $bmwdarkmodebg;
      .custom-alert-close{
        background-image: url("@/assets/default/dark/close-default-dark.svg");
      }
      &.__m{
        background-color: $minidarkmodebg;
      }
    }
    .custom-alert-close{
      &:hover{
        outline: auto;
      }
      &.disabled {
        opacity: 40%;
        outline: unset;
        cursor: default;
      }
      padding: 20px;
      margin: -20px;
      cursor: pointer;
      position: absolute;
      top: 25px;
      right: 25px;
      background-image: url("@/assets/default/light/close-default-light.svg");
      background-position: center;
      background-repeat: no-repeat;
      width: 24px;
      height: 24px;
    }
    .custom-confirm-title{
      font-size: 32px;
      line-height: 40px;
      text-align: left;
      &.__alphabet{
        text-transform: capitalize;
        font-family: AlphabetSlabPro-Medium;
        color: $alphabetblue;
      }
      &.__d {
        color: white;
      }
      &.__rr {
        font-family: RivieraNights-Light;
      }
    }
    .confirm-content{
      &.__alphabet{
        font-family: AlphabetSansPro-Medium;
        color: $alphabetblue;
      }
      &.__d {
        color: white;
      }
    }
    .custom-confirm-content{
      text-align: left;
      margin-top: 7px;
      font-size: 16px;
      line-height: 24px;
      &.__alphabet{
          font-family: AlphabetSansPro-Medium;
          color: $alphabetblue;
      }
      &.__d {
        color: white;
      }
      &.__rr {
        font-family: RivieraNights-light;
      }
    }
    .custom-confirm-buttons{
      margin-top: 26px;
      .secondary{
        float: right;
        &.__alphabet{
          background-color: transparent;
          border-color: $alphabetblue;
        }
      }
      &.full{
        button{
          &.custom-button{
            width: 100%;
          }
        }
      }
      .custom-button{
        &._profileStyle{
          &.__motorrad{
            line-height: 18px;
          }
        }
      }
    }
    .info-container {
      border: 1px solid $barGrey;

      .address-title {
        font-weight: bold;
      }
    }
    &.__m{
      padding: 95px 24px 64px;
       .custom-alert-close {
        background-image: url("@/assets/mini/light/close-mini-light.svg");
        padding: 0;
        margin: 0;
        width: 60px;
        height: 60px;
      }

      .info-container {
        border: 1px solid $miniaddressbackground;
        background-color: $miniaddressbackground;
        font-size: 18px;
        .address-title {
          font-weight: bold;
        }
      }
    }
    &.__t{
      .info-container {
        border: 1px solid $toyotared;
        font-size: 18px;
        .address-title {
          font-weight: bold;
        }
      }
    }
  }
}

//small desktop
@media screen and (max-width: 1024px) {
  .custom-alert-overlay{
    .custom-alert-confirm {
      width: 624px;
      padding: 70px 80px 80px;
      .custom-confirm-title{
        font-size: 28px;
      }
    }
  }
}

//mobile and table
@media screen and (max-width: 768px) {
  .custom-alert-overlay{
    .custom-alert-confirm {
      .custom-confirm-buttons{
        .custom-button{
          width: 100%;
          &.secondary{
            margin-top: 25px;
          }
        }
      }
      width: 320px;
      height: auto;
      padding: 70px 24px 64px;
      max-height: 95vh;
      overflow-y: auto;
    }
  }
}
</style>
